<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-8">
            <h5 class="card-title">Benutzer verwalten</h5>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table
            :data="users"
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Benutzer gefunden werden."
            v-loading="loading"
            :default-sort="{ prop: 'displayName', order: 'ascending' }"
          >
            <el-table-column prop="displayName" label="Anzeigename" min-width="130">
            </el-table-column>
            <el-table-column prop="email" label="Benutzername" min-width="150">
              <template slot-scope="scope">{{
                isLegacyEmail(scope.row.email) ? scope.row.email.split("@")[0] : scope.row.email
              }}</template>
            </el-table-column>
            <el-table-column prop="locationName" label="Standort" min-width="130" v-if="multiLocationMode == 1">
            </el-table-column>
            <el-table-column prop="customClaims.role" label="Rolle" min-width="130">
              <template slot-scope="scope"
                ><span v-if="scope.row.customClaims.role == 0">Trainer (Basis)</span
                ><span v-else-if="scope.row.customClaims.role == 1">Trainer (Standard)</span
                ><span v-else-if="scope.row.customClaims.role == 2"
                  >Parkleitung</span
                ><span v-else-if="scope.row.customClaims.role == 3"
                  >Büro</span
                ><span v-else-if="scope.row.customClaims.role == 60"
                  >EinweisungsApp</span
                ></template
              >
            </el-table-column>
            <el-table-column prop="linkedTrainerName" label="Verknüpfter Mitarbeiter" min-width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.linkedTrainerName">{{ scope.row.linkedTrainerName }}</span>
                <span v-else class="text-muted">–</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="action-buttons td-actions"
              align="right"
              label=""
            >
              <template slot-scope="props">
                <el-tooltip content="Benutzer bearbeiten" placement="top">
                  <p-button
                    type="success"
                    size="sm"
                    icon
                    @click="editUser(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Passwort zurücksetzen" placement="top">
                  <p-button
                    type="warning"
                    size="sm"
                    icon
                    @click="resetPassword(props.$index, props.row)"
                  >
                    <i class="fa fa-key"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Benutzer löschen" placement="top">
                  <p-button
                    type="danger"
                    size="sm"
                    icon
                    @click="removeUser(props.$index, props.row)"
                  >
                    <i class="fa fa-times"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-12 text-right mt-4 mb-2">
          <p-button type="primary" @click="modals.newUser = true"
            >Neuer Systembenutzer</p-button
          >
        </div>
        <div class="col-md-5">
          <h6>Berechtigungen der Benutzerrollen</h6>
          <ul>
            <li>
              <b>Basis:</b> Kann nur auf die Menüpunkte "Übersicht",
              "Retterstatus", "Kontaktliste", "Newsletter" und "Betriebsordner" für den gewählten Standort zugreifen.
            </li>
            <li>
              <b>Standard:</b> Kann nur auf die Menüpunkte "Übersicht",
              und "Hochseilgarten" für den gewählten Standort zugreifen.
            </li>
            <li class="mt-2">
              <b>Erweitert:</b> Vollzugriff auf alle Bereiche für den gewählten Standort.
            </li>
            <li class="mt-2">
              <b>Vollzugriff:</b> Vollzugriff auf alle Bereiche für alle Standorte.
            </li>
          </ul>
          <p class="text-muted">Hinweis: Der Zugriff auf die Bereiche Bau und PSA wird in den Benutzereinstellungen separat verwaltet.</p>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.editUser" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">
        Benutzer {{ this.editUsername }} bearbeiten
      </h5>
      <div class="row">
        <label class="col-md-4 col-form-label">Benutzername</label>
        <div class="col-md-8">
          <fg-input type="text" v-model="editUsername" :disabled="!editIsLegacy">
            <template slot="infoBlock"><small class="text-muted" v-if="editIsLegacy">Interner Benutzername (ohne @).</small><small class="text-muted" v-else>E-Mail-Adresse (kann nicht geändert werden).</small></template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Anzeigename</label>
        <div class="col-md-8">
          <fg-input type="text" v-model="editDisplayname"></fg-input>
        </div>
      </div>
      <div class="row mt-3" v-if="multiLocationMode == 1">
        <label class="col-md-4 col-form-label">Standort</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Standort wählen"
            filterable
            v-model="editLocation"
          >
            <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Rolle</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Rolle wählen"
            filterable
            v-model="editRole"
          >
            <el-option class="select" value="0" label="Basis" key="0">
            </el-option>
            <el-option class="select" value="1" label="Standard" key="1">
            </el-option>
            <el-option class="select" value="2" label="Erweitert" key="2">
            </el-option>
            <el-option class="select" value="3" label="Vollzugriff" key="3">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">PSA</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="PSA Rolle wählen"
            filterable
            v-model="editPsaRole"
          >
            <el-option class="select" value="0" label="Kein Zugriff" key="0">
            </el-option>
            <el-option class="select" value="1" label="Lesender Zugriff" key="1">
            </el-option>
            <el-option class="select" value="4" label="Vollzugriff" key="4">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Bau</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Bau Rolle wählen"
            filterable
            v-model="editConstructionRole"
          >
            <el-option class="select" value="0" label="Kein Zugriff" key="0">
            </el-option>
            <el-option class="select" value="1" label="Lesender Zugriff" key="1">
            </el-option>
            <el-option class="select" value="2" label="Inspektionen durchführen" key="2">
            </el-option>
            <el-option class="select" value="4" label="Vollzugriff" key="4">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Retterprüfungen</label>
        <div class="col-md-8 d-flex align-items-center">
          <input type="checkbox" v-model="editRetterpruefungRole" style="width: 18px; height: 18px;">
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="modals.editUser = false"
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="modifyUser">Speichern</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="modals.newUser" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Neuen Systembenutzer anlegen</h5>
      <div class="alert alert-info mt-2"><i class="fa fa-exclamation-triangle"></i> Verwende dieses Formular nur zum Anlegen von nicht-personenbezogenen Systembenutzern.<br>Personenbezogene Accounts für Mitarbeiter müssen über das Mitarbeiter-Menü angelegt werden, damit diese mit dem entsprechenden Mitarbeiter verknüpft werden können.</div>
      <div class="row">
        <label class="col-md-4 col-form-label">Benutzername</label>
        <div class="col-md-8">
          <fg-input type="text" v-model="newUsername">
            <template slot="infoBlock"><small class="text-muted">E-Mail-Adresse (z.B. name@example.com) oder interner Benutzername (ohne @).</small></template>
          </fg-input>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Anzeigename</label>
        <div class="col-md-8">
          <fg-input type="text" v-model="newDisplayname"></fg-input>
        </div>
      </div>
      <div class="row mt-3" v-if="multiLocationMode == 1">
        <label class="col-md-4 col-form-label">Standort</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Standort wählen"
            filterable
            v-model="newLocation"
          >
            <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Rolle</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Rolle wählen"
            filterable
            v-model="newRole"
          >
            <el-option class="select" value="0" label="Basis" key="0">
            </el-option>
            <el-option class="select" value="1" label="Standard" key="1">
            </el-option>
            <el-option class="select" value="2" label="Erweitert" key="2">
            </el-option>
            <el-option class="select" value="3" label="Vollzugriff" key="3">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">PSA</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="PSA Rolle wählen"
            filterable
            v-model="newPsaRole"
          >
            <el-option class="select" value="0" label="Kein Zugriff" key="0">
            </el-option>
            <el-option class="select" value="1" label="Lesender Zugriff" key="1">
            </el-option>
            <el-option class="select" value="4" label="Vollzugriff" key="4">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Bau</label>
        <div class="col-md-8">
          <el-select
            class="select"
            placeholder="Bau Rolle wählen"
            filterable
            v-model="newConstructionRole"
          >
            <el-option class="select" value="0" label="Kein Zugriff" key="0">
            </el-option>
            <el-option class="select" value="1" label="Lesender Zugriff" key="1">
            </el-option>
            <el-option class="select" value="2" label="Inspektionen durchführen" key="2">
            </el-option>
            <el-option class="select" value="4" label="Vollzugriff" key="4">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-3">
        <label class="col-md-4 col-form-label">Retterprüfungen</label>
        <div class="col-md-8 d-flex align-items-center">
          <input type="checkbox" v-model="newRetterpruefungRole" style="width: 18px; height: 18px;"> <span class="ml-2">Zugriff</span>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button
            type="default"
            link
            @click="
              modals.newUser = false;
              newUsername = null;
              newDisplayname = null;
              newLocation = null;
              newRole = null;
              newPsaRole = null;
              newConstructionRole = null;
              newRetterpruefungRole = false;
            "
            >Abbrechen</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addUser"
            >Benutzer anlegen</p-button
          >
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { firebaseApp, fc, db } from "../../../../firebaseDb";
import {
  Table,
  TableColumn,
  Tooltip,
  Input,
  Loading,
  Select,
  Option,
  MessageBox,
  Alert,
} from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import firebase from "firebase/compat/app";
import { httpsCallable } from "firebase/functions";
import locations from "../../../../locationStore";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(Loading);

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox,
    Modal,
  },

  data() {
    return {
      users: [],
      loading: true,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      modals: {
        editUser: false,
        newUser: false,
      },
      editUsername: null,
      editUID: null,
      editDisplayname: null,
      editRole: null,
      editLocation: null,
      editPsaRole: null,
      editConstructionRole: null,
      editRetterpruefungRole: false,
      editIsLegacy: true,

      newUsername: null,
      newDisplayname: null,
      newRole: null,
      newPsaRole: null,
      newConstructionRole: null,
      newRetterpruefungRole: false,
      newLocation: locations.getters.locations.locations[0]['key'],

      multiLocationMode: process.env.VUE_APP_MULTIPLE_LOCATIONS,
      locations: locations.getters.locations.locations,
    };
  },
  created() {
    if(store.getters.userrole != "3") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    } else {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.users = [];
      // get list of users
      var list = httpsCallable(fc, "users-listUsers");
      list([]).then((result) => {
        this.users = result.data.users;
        // remove master user from list
        this.users = this.users.filter(function (user) {
          return user.email != "master@verti-hub.com";
        });
        // add location names
        for (var user of this.users) {
          var locationName = "-";
          for (var loc of this.locations) {
            if (loc.key == user.customClaims.location) {
              locationName = loc.name;
            }
          }
          user.locationName = locationName;
          user.linkedTrainerName = null;
        }
        // resolve linked trainer names
        const linkedUsers = this.users.filter(u => u.customClaims && u.customClaims.linkedTrainerId);
        const trainerIds = [...new Set(linkedUsers.map(u => u.customClaims.linkedTrainerId))];
        if (trainerIds.length > 0) {
          const promises = trainerIds.map(id => db.collection('trainer').doc(id).get());
          Promise.all(promises).then((docs) => {
            const trainerMap = {};
            docs.forEach(doc => {
              if (doc.exists) {
                trainerMap[doc.id] = doc.data().Name;
              }
            });
            for (var user of this.users) {
              if (user.customClaims && user.customClaims.linkedTrainerId && trainerMap[user.customClaims.linkedTrainerId]) {
                user.linkedTrainerName = trainerMap[user.customClaims.linkedTrainerId];
              }
            }
            // Force reactivity update
            this.users = [...this.users];
          });
        }
        this.loading = false;
      });
    },
    editUser(index, row) {
      this.editUID = row.uid;
      this.editIsLegacy = this.isLegacyEmail(row.email);
      this.editUsername = this.editIsLegacy ? row.email.split("@")[0] : row.email;
      this.editDisplayname = row.displayName;
      this.editRole = row.customClaims.role;
      this.editLocation = row.customClaims.location;
      this.editPsaRole = row.customClaims.psaRole;
      this.editConstructionRole = row.customClaims.constructionRole;
      this.editRetterpruefungRole = row.customClaims.retterpruefungRole === true;
      this.modals.editUser = true;
    },
    modifyUser() {
      if (this.editUsername.includes(" ")) {
        MessageBox.alert(
          "Der Benutzername darf keine Leerzeichen enthalten.",
          { confirmButtonText: "OK", type: "error", callback: () => {} }
        );
        return;
      }
      this.modals.editUser = false;
      this.loading = true;
      const username = this.editIsLegacy
        ? this.editUsername + "@" + process.env.VUE_APP_USERNAME_SUFFIX
        : this.editUsername;
      var modify = httpsCallable(fc, "users-modifyUser");
      modify({
        uid: this.editUID,
        username: username,
        displayName: this.editDisplayname,
        location: this.editLocation,
        role: this.editRole,
        psaRole: this.editPsaRole,
        constructionRole: this.editConstructionRole,
        retterpruefungRole: this.editRetterpruefungRole,
      }).then((result) => {
        this.loadData();
      });
    },
    addUser() {
      if (
        this.newUsername &&
        this.newDisplayname &&
        this.newLocation &&
        this.newRole
      ) {
        if (this.newUsername.includes(" ")) {
          MessageBox.alert(
            "Der Benutzername darf keine Leerzeichen enthalten.",
            { confirmButtonText: "OK", type: "error", callback: () => {} }
          );
          return;
        }
        const username = this.newUsername.includes("@")
          ? this.newUsername
          : this.newUsername + "@" + process.env.VUE_APP_USERNAME_SUFFIX;
        if (this.userExists(username)) {
          MessageBox.alert(
            "Der Benutzer " + this.newUsername + " existiert bereits.",
            { confirmButtonText: "OK", type: "warning", callback: () => {} }
          );
        } else {
          this.modals.newUser = false;
          this.loading = true;
          var add = httpsCallable(fc, "users-addUser");
          add({
            username: username,
            displayName: this.newDisplayname,
            location: this.newLocation,
            role: this.newRole,
            psaRole: this.newPsaRole,
            constructionRole: this.newConstructionRole,
            retterpruefungRole: this.newRetterpruefungRole,
          }).then((result) => {
            this.loading = false;
            MessageBox.alert(
              "Der Benutzer " +
                this.newUsername +
                " wurde erfolgreich angelegt. Das Passwort lautet: " +
                result.data,
              {
                confirmButtonText: "OK",
                type: "success",
                callback: (action) => {},
              }
            );
            this.newUsername = null;
            this.newDisplayname = null;
            this.newLocation = null;
            this.newRole = null;
            this.loadData();
          });
        }
      }
    },
    resetPassword(index, row) {
      this.loading = true;
      var reset = httpsCallable(fc, "users-resetPassword");
      reset({ uid: row.uid }).then((result) => {
        this.loading = false;
        MessageBox.alert(
          "Das Passwort von " +
            row.displayName +
            " wurde erfolgreich geändert. Das neue Passwort lautet: " +
            result.data,
          {
            confirmButtonText: "OK",
            type: "success",
            callback: (action) => {},
          }
        );
      });
    },
    removeUser(index, row) {
      MessageBox.confirm(
        "Soll der Benutzer " + row.displayName + " endgültig gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              // remove user
              this.loading = true;
              var remove = httpsCallable(fc, "users-removeUser");
              remove({ uid: row.uid }).then((result) => {
                this.loadData();
              });
            }
          },
        }
      );
    },
    isLegacyEmail(email) {
      return email && email.endsWith("@" + process.env.VUE_APP_USERNAME_SUFFIX);
    },
    userExists(fullEmail) {
      return this.users.some(function (el) {
        return el.email === fullEmail;
      });
    },
  },
};
</script>
<style>
</style>
